import { useLocation } from "react-router-dom";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import AIConciergeDrawer from "@/components/AIConciergeDrawer";

export default function PaymentAdvisorPage() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="max-w-3xl">
      <PageHeader eyebrow="AI · Claude Sonnet 4.5" title="Payment Advisor" subtitle="Understand your balance, aging, and payment plans." />
      <Card className={"h-[70vh] overflow-hidden flex flex-col " + (isAdmin ? "border-white/10 bg-card" : "bg-white")}>
        <div className="flex-1 min-h-0">
          <AIConciergeDrawer agent="payment_advisor" theme={isAdmin ? "dark" : "light"} />
        </div>
      </Card>
    </div>
  );
}
